var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		("tag align-center border " + _vm.colorClasses + " " + _vm.sizeClasses + " " + _vm.spacingClasses + " " + _vm.displayClasses + " " + _vm.customClass)
	],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }